import React from 'react';

import CrossIcon from 'widget/shared/icons/CrossIcon';
import { IconColor, IconSize } from 'widget/shared/icons/BaseIcon';
import { WidgetTexts } from 'widget/consts/texts';

import IconButton from '../../IconButton';

import styles from './ClearButton.module.scss';

export type ClearButtonProps = {
  onClick: () => void;
};

const ClearButton: React.FC<ClearButtonProps> = ({ onClick }) => {
  const handleMouseDown = React.useCallback(
    (e: React.MouseEvent) => {
      // Предотвращаем потерю фокуса с инпута
      e.preventDefault();
      onClick();
    },
    [onClick]
  );

  return (
    <IconButton
      className={styles['clear-button']}
      onMouseDown={handleMouseDown}
      tabIndex={-1}
      aria-label={WidgetTexts.shared.clearButton}
    >
      <CrossIcon size={IconSize.XS} color={IconColor.Gray} />
    </IconButton>
  );
};

export default React.memo(ClearButton);
